import { Routes } from '@angular/router';
import { DialogNames, LazyDialogLoader } from '@qtek/libs/dialog-loader';

export const dialogRoutes: Routes = [
  {
    path: DialogNames.alert,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import('./standalone-dialogs/alert-dialog/alert-dialog.component').then(
        c => c.AlertDialogComponent
      ),
  },
  {
    path: DialogNames.confirm,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './standalone-dialogs/confirm-dialog/confirm-dialog.component'
      ).then(c => c.ConfirmDialogComponent),
  },

  {
    path: DialogNames.imageCrop,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './standalone-dialogs/image-crop-dialog/image-crop-dialog.component'
      ).then(c => c.ImageCropDialogComponent),
  },

  {
    path: DialogNames.gallery,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import('./standalone-dialogs/gallery/gallery.component').then(
        c => c.GalleryComponent
      ),
  },
  {
    path: DialogNames.colorPicker,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './standalone-dialogs/color-picker-dialog/color-picker-dialog.component'
      ).then(c => c.ColorPickerDialogComponent),
  },

  {
    path: DialogNames.secureConfirm,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './standalone-dialogs/secure-confirm-dialog/secure-confirm-dialog.component'
      ).then(c => c.SecureConfirmDialogComponent),
  },

  {
    path: DialogNames.numericKeyboard,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './standalone-dialogs/numeric-keyboard-dialog/numeric-keyboard-dialog.component'
      ).then(c => c.NumericKeyboardDialogComponent),
  },

  {
    path: DialogNames.deliveryDialog,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './standalone-dialogs/delivery-dialog/delivery-dialog.component'
      ).then(c => c.DeliveryDialogComponent),
  },

  {
    path: DialogNames.createItem,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './standalone-dialogs/create-participant-dialog/create-participant-dialog.component'
      ).then(c => c.CreateParticipantDialogComponent),
  },
  {
    path: DialogNames.selectDealType,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './standalone-dialogs/deal-type-selection-dialog/deal-type-selection-dialog.component'
      ).then(c => c.DealTypeSelectionDialogComponent),
  },
  {
    path: DialogNames.closedDealStepper,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './standalone-dialogs/closed-deal-stepper-dialog/closed-deal-stepper-dialog.component'
      ).then(c => c.ClosedDealStepperDialogComponent),
  },
  {
    path: DialogNames.closedDealEntryMethod,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './standalone-dialogs/closed-deal-entry-method-dialog/closed-deal-entry-method-dialog.component'
      ).then(c => c.ClosedDealEntryMethodDialogComponent),
  },
  {
    path: DialogNames.currentDealEntryMethod,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './standalone-dialogs/current-deal-entry-method-dialog/current-deal-entry-method-dialog.component'
      ).then(c => c.CurrentDealEntryMethodDialogComponent),
  },
  {
    path: DialogNames.termSheetReview,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './standalone-dialogs/term-sheet-review-dialog/term-sheet-review-dialog.component'
      ).then(c => c.TermSheetReviewDialogComponent),
  },
  {
    path: DialogNames.benchmarkPublish,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './standalone-dialogs/benchmark-publish-dialog/benchmark-publish-dialog.component'
      ).then(c => c.BenchmarkPublishDialogComponent),
  },
  {
    path: DialogNames.addContextDocDialog,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './standalone-dialogs/add-context-doc-dialog/add-context-doc-dialog.component'
      ).then(c => c.AddContextDocDialogComponent),
  },
  {
    path: DialogNames.extractionOptIn,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './standalone-dialogs/extraction-opt-in-dialog/extraction-opt-in-dialog.component'
      ).then(c => c.ExtractionOptInDialogComponent),
  },
  {
    path: DialogNames.extractionReview,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './standalone-dialogs/extraction-review-dialog/extraction-review-dialog.component'
      ).then(c => c.ExtractionReviewDialogComponent),
  },
  {
    path: DialogNames.scannedDocumentWarning,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './standalone-dialogs/scanned-document-warning-dialog/scanned-document-warning-dialog.component'
      ).then(c => c.ScannedDocumentWarningDialogComponent),
  },
  {
    path: DialogNames.employeeDialog,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './standalone-dialogs/employee-dialog/employee-dialog.component'
      ).then(c => c.EmployeeDialogComponent),
  },
  {
    path: DialogNames.inviteContact,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './standalone-dialogs/invite-contact-dialog/invite-contact-dialog.component'
      ).then(c => c.InviteContactDialogComponent),
  },
  {
    path: DialogNames.promptData,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import('./standalone-dialogs/prompt-dialog/prompt-dialog.component').then(
        c => c.PromptDialogComponent
      ),
  },
  {
    path: DialogNames.customerDialog,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './standalone-dialogs/customer-dialog/customer-dialog.component'
      ).then(c => c.CustomerDialogComponent),
  },
  {
    path: DialogNames.noteDialog,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import('./standalone-dialogs/note-dialog/note-dialog.component').then(
        c => c.NoteDialogComponent
      ),
  },
  {
    path: DialogNames.informationDialog,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './standalone-dialogs/information-dialog/information-dialog.component'
      ).then(c => c.InformationDialogComponent),
  },
  {
    path: DialogNames.fileUploaderDialog,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './standalone-dialogs/file-uploader-dialog/file-uploader-dialog.component'
      ).then(c => c.FileUploaderDialogComponent),
  },
  {
    path: DialogNames.ndaDialog,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import('./standalone-dialogs/nda-dialog/nda-dialog.component').then(
        c => c.NdaDialogComponent
      ),
  },

  {
    path: DialogNames.companyNdasUpload,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './standalone-dialogs/contact-ndas-upload-dialog/contact-ndas-upload-dialog.component'
      ).then(c => c.ContactNdasUploadDialogComponent),
  },

  {
    path: DialogNames.companyNdasPreview,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './standalone-dialogs/contact-ndas-preview-dialog/contact-ndas-preview-dialog.component'
      ).then(c => c.ContactNdasPreviewDialogComponent),
  },
  {
    path: DialogNames.taskDialog,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import('@qtek/libs/tasks').then(c => c.TasksDialogComponent),
  },

  {
    path: DialogNames.contactDialog,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import('./module-dialogs/contact-dialog/contact-dialog.component').then(
        c => c.ContactDialogComponent
      ),
  },
  {
    path: DialogNames.contactPreview,
    canActivate: [LazyDialogLoader],
    loadComponent: () =>
      import(
        './module-dialogs/contact-preview-dialog/contact-preview-dialog.component'
      ).then(c => c.ContactPreviewDialogComponent),
  },
];
